import React, { useState } from 'react';
import classnames from 'classnames';
import { ResidentialSellersNetBody } from './TableBody';

const SellersNetTable = ({
  formProps,
  lessClosingCostsResults,
  title,
  subtitle,
  className,
  totals,
  ...props
}) => {
  return (
    <>
      <h1 className="calc__title">{title}</h1>
      <h2 className="calc__title--sub">{subtitle}</h2>
      <table className={classnames('table', className)}>
        <ResidentialSellersNetBody
          {...lessClosingCostsResults}
          formProps={formProps}
          totals={totals}
        />
      </table>
    </>
  );
};

export default SellersNetTable;
